import { IContentBlockInstance } from '@/models/content-page.model';
import { richTextToPlainText } from './richText';

export const getBlockSummary = (block: IContentBlockInstance, typeLabel: string): string => {
  const excerpt = (raw: string) => richTextToPlainText(raw).slice(0, 80);
  const d = block.data;
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    const o = d as Record<string, unknown>;
    const text = o.text;
    if (typeof text === 'string') return excerpt(text) || typeLabel;
    if (text && typeof text === 'object') {
      const first = Object.values(text as Record<string, string>)[0];
      if (typeof first === 'string') return excerpt(first);
    }
    const heading = o.heading;
    if (typeof heading === 'string') return excerpt(heading) || typeLabel;
    if (heading && typeof heading === 'object') {
      const first = Object.values(heading as Record<string, string>)[0];
      if (typeof first === 'string') return excerpt(first);
    }
  }
  return typeLabel;
};
